import React from 'react';
import PropTypes from 'prop-types';
import { ExternalLink } from 'lucide-react';
import { Flex, Text, Box } from 'rebass/styled-components';
import { Button } from '@getro/rombo';

export const SurveyCallout = ({ user, activeNetwork, onTrack }) => (
  <Box width="600px" sx={{ borderTop: '1px solid', borderColor: '#dee4ed', pt: '24px', mt: '24px' }}>
    <Flex flexDirection={['column', 'row']} justifyContent="space-between" sx={{ gap: '16px' }}>
      <Flex flexDirection="column" fontSize="14px" lineHeight="1.4">
        <Text color="text.dark" fontWeight="500">
          What integrations would be most useful for you?
        </Text>
        <Text color="text.subtle" fontSize="14px" lineHeight="1.4">
          Fill out a quick survey to help us prioritize our roadmap.
        </Text>
      </Flex>
      <Button
        size="small"
        variant="secondary"
        icon={ExternalLink}
        iconPosition="right"
        onClick={() => {
          const base = 'https://getro-forms.typeform.com/to/NAc6nhPQ';
          const params = new URLSearchParams({
            email: user.email,
            name: `${user.firstName} ${user.lastName}`,
          });
          if (activeNetwork) {
            params.set('collection_name', activeNetwork.name);
            params.set('collection_id', String(activeNetwork.id));
          }
          window.open(`${base}?${params.toString()}`, '_blank');
          onTrack?.();
        }}
      >
        Go to survey
      </Button>
    </Flex>
  </Box>
);

SurveyCallout.propTypes = {
  user: PropTypes.object.isRequired,
  activeNetwork: PropTypes.object,
  onTrack: PropTypes.func,
};

SurveyCallout.defaultProps = {
  activeNetwork: null,
  onTrack: undefined,
};
